import TranslationText from '@Components/Utilities/TranslationText';

const CompareCheckbox = (props) => {
    return (
        <>
            {(!props.IsDisabled || props.IsCheckedForCompare) &&
                <>
                    <div className={'compare-listings ' + props.classNames ? props.classNames : ''}>
                        <label htmlFor={'compare-checkbox-' + props.Id} className='compare-listings__label'>
                            <input type='checkbox' id={'compare-checkbox-' + props.Id} className='compare-listings__checkbox' onChange={props.UpdateCompareListing} checked={props.IsCheckedForCompare} />
                            <span className='compare-listings__label-text'><TranslationText tKey='sandhills.compare' /></span>
                        </label>
                    </div>
                    {props.IsCheckedForCompare &&
                        <div className='compare-listings_checked'>
                            <a href={props.CompareUrl}><TranslationText className='compare-listings__link' tKey='Sandhills.CompareSelectedListings' /></a>
                        </div>}
                </>}
        </>
    );
};

export default CompareCheckbox;